<template>
  <div class="app">
    <router-view/>
  </div>
</template>
<script>


export default {
  mounted(){
     window.location.hash = '/'
  }
}

</script>

<style lang="less">
@import url('./assets/style/reset.css');
</style>



// WEBPACK FOOTER //
// src/App.vue